import { getOrderList } from '@/apis/base';

export default {
  namespaced: true,
  state: () => {
    return {
      orderList: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 10
      },
      searchList: []
    };
  },
  actions: {
    async getOrder ({commit, state}, { pageSize = 10, pageIndex = 1 }) {
      try {
        const res = await getOrderList(pageIndex, pageSize);
        commit('setOrderList', res._data.orderList);
        commit('setPageInfo', res._data.pageInfo);
      } catch (e) {
        console.log('order', e);
      }
    },
    async getMoreOrder ({commit, rootState, state, getters}) {
      let orderList = state.orderList;
      let pageIndex = parseInt(state.pageInfo.pageIndex) + 1;
      try {
        const res = await getOrderList(pageIndex, state.pageInfo.pageSize);
        res._data.orderList = orderList.concat(res._data.orderList);
        commit('setOrderList', res._data.orderList);
        commit('setPageInfo', res._data.pageInfo);
      } catch (e) {
        console.log('order', e);
      }
    },
    async search ({commit}, kw) {
      try {
        const res = await getOrderList(1, 10, kw);
        commit('setSearchList', res._data.orderList);
      } catch (e) {
        console.log('search', e);
      }
    }
  },
  mutations: {
    setOrderList (state, data) {
      state.orderList = data;
    },
    setPageInfo (state, data) {
      state.pageInfo = data;
    },
    setSearchList (state, data) {
      state.searchList = data;
    }
  },
  getters: {
    hasMoreOrder (state) {
      return state.orderList.length && (state.orderList.length < Number(state.pageInfo.total));
    },
    pageInfo (state) {
      return {
        pageIndex: parseInt(state.pageInfo.pageIndex),
        pageSize: parseInt(state.pageInfo.pageSize),
        total: parseInt(state.pageInfo.total)
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/order-list/store.js